import { Component, Input } from '@angular/core';
import { Category } from 'src-ironside/repositories/category.repository';
import { AccueilDataService } from 'src-ironside/services/accueil-data.service';
import { CommonService } from 'src-ironside/services/common.service';
import { ScreenMediator } from 'src-ironside/services/screen.mediator';
import { SessionStorageService } from 'src-ironside/services/session-storage.service';
import { CategorieTree } from 'src-ironside/shared/models/categories';

export type BreadCrumbItem = {
    name: string;
    url?: string;
    id?: string;
    categories?: any;
    isEnable?: boolean;
};

@Component({
    selector: 'app-bread-crumb',
    templateUrl: './bread-crumb.component.html',
    styleUrls: ['./bread-crumb.component.css'],
})
export class BreadCrumbComponent {
    @Input() data: BreadCrumbItem[];

    catalogs: any;

    constructor(
        private screenMediator: ScreenMediator,
        private accueilDataService: AccueilDataService,
        private _commonService: CommonService,
        private sessionStorageService: SessionStorageService
    ) {}

    ngAfterViewInit(): void {
        this._commonService.getCategories().subscribe((res) => {
            this.catalogs = res;
        });
    }

    onRedirectCatalog(item: any) {
        if (item.id && this.catalogs?.length) {
            const catalogSelected = this.findNodeByCode(this.catalogs, item?.id!);
            this.sessionStorageService.setFilters({
                isCategoryModal: false,
                categoryList: [item.id],
                catalogName: item?.categories?.nameCategory,
            });
            this.accueilDataService.filterData = {
                categoryName: item?.categories?.nameCategory!,
                categoryList: [catalogSelected],
            };
            this.screenMediator.toRecherche();
        }
    }

    findNodeByCode(tree: Category[], id: string): any | null {
        if (!tree) return null;

        for (const node of tree) {
            if (node?.id === id) {
                return node;
            }

            if (node?.subcategoryList) {
                const foundNode = this.findNodeByCode(node.subcategoryList, id);
                if (foundNode) {
                    return foundNode;
                }
            }
        }

        return null;
    }
}
